// 🚨 Will fix after merge
/* eslint-disable @typescript-eslint/no-explicit-any */
export const isMultipleExceptions = (exceptions: any[] | undefined) => {
  const workorderExceptions: any[] = [];

  exceptions?.forEach(
    (exception: {
      shippingAndHandling: { applianceDeliveries: any[] };
      bodfsDeliveryAndHandling: { bodfsDeliveries: any[] };
    }) => {
      if (
        exception?.shippingAndHandling &&
        exception?.shippingAndHandling?.applianceDeliveries
      ) {
        const applianceDeliveries =
          exception?.shippingAndHandling?.applianceDeliveries[0];
        const workOrderException = applianceDeliveries?.workOrderException;

        if (
          workOrderException &&
          !workorderExceptions.includes(workOrderException)
        ) {
          workorderExceptions.push(workOrderException);
        }
      }

      if (
        exception?.bodfsDeliveryAndHandling &&
        exception?.bodfsDeliveryAndHandling?.bodfsDeliveries
      ) {
        const bodfsDelivery =
          exception?.bodfsDeliveryAndHandling?.bodfsDeliveries[0];
        const workOrderException = bodfsDelivery?.workOrderException;

        if (
          workOrderException &&
          !workorderExceptions.includes(workOrderException)
        ) {
          workorderExceptions.push(workOrderException);
        }
      }
    },
  );

  if (workorderExceptions.length > 1) {
    return 'Multiple';
  }
  return workorderExceptions[0];
};
